import styled from 'styled-components';
import { media, remCalc } from 'src/components/base';
import { Grid } from 'src/components/flexible-grid';
import { minCardWidth } from '../brand-category-card/styles';

const baseMargin = 8;

export const CategoryGrid = styled(Grid).attrs({
  gap: remCalc(baseMargin),
  columnCount: 'auto-fit',
  columnMinWidth: remCalc(minCardWidth),
})`
  margin-top: ${remCalc(baseMargin * 2)};

  ${media.mediumDown`
    grid-template-columns: repeat(auto-fit, 1fr);

    /* Hide the last element to get a more even number of grid items. */
    & > :last-child {
      display: none;
    }
  `}
`;

export const CategoryTree = styled.div`
  margin-top: 40px;
`;
